export const tableHeadersConfig = [
  {
    id: 1,
    title: 'Company name',
    value: 'company-name',
  },
  {
    id: 2,
    title: 'Person name',
    value: 'person-name',
  },
  {
    id: 3,
    title: 'Purchased at',
    value: 'purchased-at',
  },
]
